module.exports = __webpack_public_path__ + "static/media/changeme.2e4cc214.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/changeme.md
// module id = 1094
// module chunks = 0